document.addEventListener('DOMContentLoaded', () => {
    const idCategory = document.querySelector('.js-es-page-open')?.getAttribute('data-catalog-id');

    if (idCategory && idCategory.length) {
        const data = {
            'category': document.querySelector('h1').textContent, // строка - наименование категории, формат String
            'category_id': idCategory, // формат Int64, идентификатор из YML
        };

        (window.sndsyApiOnReady = window.sndsyApiOnReady || []).push(() => {
            window.sndsyApi.ssecEvent(
                'VIEW_CATEGORY', [data],
            );
        });

        // eslint-disable-next-line no-unused-expressions
        typeof window.sndsyApi !== 'undefined' && window.sndsyApi.runQueue();
        console.log(' ♑ ViewCategorySS()', data);
    }
});